import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const RecruitmentListItem = ({ item, number, onPress }) => {
    const { t: tJobOffer } = useTranslation("jobOffer");

    const title = `${number}. ${item.name}${item.companyName ? ` - ${item.companyName}` : ""}`;
    const subtitle = `${item.location} - ${tJobOffer(`enums.WORK_MODE.${item.workMode.toLowerCase()}`)}`;

    return (
        <Box
            as="button"
            type="button"
            w="70%"
            textAlign="left"
            px={4}
            py={3}
            bg="bg.chatItem"
            border="1px solid"
            borderColor="border.inputLight"
            borderRadius={8}
            cursor="pointer"
            _hover={{ bg: "bg.chatItemHover" }}
            transition="background 0.15s"
            onClick={onPress}
        >
            <Text color="gray.800" fontWeight="medium">
                {title}
            </Text>
            <Text color="gray.500" fontSize="sm">
                {subtitle}
            </Text>
        </Box>
    );
};

export default RecruitmentListItem;
